import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, auth: { isAuthenticated }, ...rest }) => {
  return (
    <Route
    // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) => {
        return (!localStorage.token && !isAuthenticated ? (<Redirect to="/login" />)
          // eslint-disable-next-line react/jsx-props-no-spreading
          : (<Component {...props} />));
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(PrivateRoute);
